import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import ListItem from "@material-ui/core/ListItem";

import { useStyles } from "./ClassDetails.css.js";

class ClassDetails extends Component {
  render() {
    const { classes, config } = this.props;
    return (
      <div className={classes.root}>
        <div className={classes.content}>
          <ListItem divider>
            <b style={{ flexGrow: 1 }}>Class:</b>
            <div>{config.class}</div>
          </ListItem>
          {config.faculty && (
            <ListItem divider>
              <b style={{ flexGrow: 1 }}>Faculty:</b>
              <div>{config.faculty}</div>
            </ListItem>
          )}
        </div>
        <div className={classes.content}>
          {config.group && (
            <ListItem divider>
              <b style={{ flexGrow: 1 }}>Group:</b>
              <div>{config.group}</div>
            </ListItem>
          )}
          <ListItem divider>
            <b style={{ flexGrow: 1 }}>Section:</b>
            <div>{config.section}</div>
          </ListItem>
        </div>
      </div>
    );
  }
}

export default withStyles(useStyles)(ClassDetails);
